// noinspection JSAnnotator
const state = {
  licenses: [],
  license: []
};

// noinspection JSAnnotator
const mutations = {
  'SET_LICENSE_DETAILS'(state, detail) {
    state.license = [];
    if (detail) {
      state.license = detail;
    }
  },
  'GET_LICENSE_DETAILS'() {
    return state.license;
  },
  'UPDATE_LICENSE_DETAILS'(state, detail) {
    state.license.unshift(detail);
  },
  'REMOVE_LICENSE_DETAILS'() {
    state.license = [];
  },

  'SET_LICENSES_DETAILS'(state, detail) {
    state.licenses = [];
    if (detail) {
      if (detail.length > 0) {
        state.licenses = detail;
      }
    }
  },
  'GET_LICENSES_DETAILS'() {
    return state.licenses;
  },
  'UPDATE_LICENSES_DETAILS'(state, detail) {
    state.licenses.unshift(detail);
  },
  'REMOVE_LICENSES_DETAILS'() {
    state.licenses = [];
  },
};

const actions = {
  getLicenseDetail: ({commit}, detail) => {
    commit('GET_LICENSE_DETAILS', detail);
  },
  setLicenseDetail: ({commit}, detail) => {
    commit('SET_LICENSE_DETAILS', detail);
  },
  updateLicenseDetail: ({commit}, detail) => {
    commit('UPDATE_LICENSE_DETAILS', detail);
  },

  getLicenseListDetail: ({commit}, detail) => {
    commit('GET_LICENSES_DETAILS', detail);
  },
  setLicenseListDetail: ({commit}, detail) => {
    commit('SET_LICENSES_DETAILS', detail);
  },
  updateLicenseListDetail: ({commit}, detail) => {
    commit('UPDATE_LICENSES_DETAILS', detail);
  },
  removeLicenseList: ({commit}, detail) => {
    commit('REMOVE_LICENSES_DETAILS', detail);
  }
};

const getters = {
  getLicenseDetail: (state) => {
    return state.license;
  },
  getLicenseListDetail: () => {
    return state.licenses;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};




// WEBPACK FOOTER //
// ./src/store/modules/License.store.js